import { useState, createContext, useContext } from "react";

// creating a custom hook
const ThemeContext = createContext();

// to use this custom hook we need a provider
const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");
  return (
    <ThemeContext.Provider value={[theme, setTheme]}>
      {children}
    </ThemeContext.Provider>
  );
};

// exporting this custom hook to use it anywhere
const useTheme = () => useContext(ThemeContext);

export { useTheme, ThemeProvider };
